import maModal from '@/components/modal'
import maForm from '@/components/form'
import maButton from '@/components/button-blue'
import maNotifications from '@/components/notifications'
import maSpinner from '@/components/spinner'
import maDamageItemPhotoclaim from './../damageItemPhotoclaim'
import { mapState, mapActions, mapMutations } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_UPDATE_MURS_TOTAL_COUNT
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
  name: 'multidamagePhotoclaimForm',

  mixins: [flowMixin],

  props: {
    damageReport: {
      required: true,
      type: Object
    },
    pieceId: {
      required: true,
      type: Number | null
    },
    damagedPart: {
      required: true,
      type: Object | null
    },
    pieceSurface: {
      required: true,
      type: Number | null
    },
    editIndex: {
      required: false,
      type: Number | null,
      default: null
    },
    damagedPhotos: {
      required: false,
      type: Object | null
    },
    damagesDetected: {
      type: Array | null,
      required: false
    }
  },

  components: {
    maModal,
    maForm,
    maButton,
    maNotifications,
    maSpinner,
    maDamageItemPhotoclaim
  },

  data() {
    return {
      loading: false,
      spinner: false
    }
  },

  computed: {
    ...mapState(USER_MODULE_NAME, {
      stateUserType: 'userType'
    }),

    report() {
      return {
        ...this.damageReport,
        SUPPORT: this.damagedPart.key
      }
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutStateWarrantyUpdateMursTotalCount: WARRANTY_UPDATE_MURS_TOTAL_COUNT
    }),

    showModal() {
      this.loading = false
      this.spinner = false
      this.$refs.modalMultidamagePhotoclaimForm.showModal = true
    },

    hideModal() {
      this.resetForms()
      this.$emit('form:partDamagePhotoclaimCanceled')
      this.$refs.modalMultidamagePhotoclaimForm.showModal = false
    },

    handleConfirmBtn() {
      this.resetForms()
      this.$refs.modalMultidamagePhotoclaimForm.showModal = false
      this.$emit('form:partDamagePhotoclaimFinished')
    },

    resetForms() {
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReportMurs()
    }
  }
}
